export default __webpack_public_path__ + "images/models/386364fd0366db2fe64610859f2de0b9.glb";